<template>
    <div class="custom-filter flex gap-x-2 items-end flex-wrap ml-4 my-4">
        <div class="flex flex-col">
            <div class="my-1 text-gray-500">Busqueda</div>
            <div class="search-bar">
                <InputText
                    placeholder="orden, destinatario, tracking..."
                    class="h-[42px]"
                    v-model="filtersData.query"
                    @keydown.enter="$emit('getFilteredShipment')"
                />
                <Button
                    class="p-button-info h-[42px]"
                    icon="pi pi-search"
                    :loading="loading"
                    @click="$emit('getFilteredShipment')"
                />
            </div>
        </div>
        <div
            v-if="
                $page.props.user.tipo === 'super_admin' ||
                $page.props.user.tipo === 'global_admin'
            "
            class="flex flex-col"
        >
            <div class="my-1 text-gray-500">Cliente</div>
            <Dropdown
                v-model="filtersData.cliente"
                :options="clientes"
                optionLabel="nombre"
                optionValue="id"
                class="filter-container h-[42px]"
                placeholder="Cliente"
                @change="$emit('getFilteredShipment')"
            />
        </div>
        <div class="flex flex-col">
            <div class="my-1 text-gray-500">Estado</div>
            <Dropdown
                v-model="filtersData.estado"
                :options="estados"
                optionLabel="name"
                optionValue="value"
                class="filter-container h-[42px]"
                placeholder="Estado"
                @change="$emit('getFilteredShipment')"
            />
        </div>
        <div class="flex flex-col">
            <div class="my-1 text-gray-500">Proveedor</div>
            <Dropdown
                v-model="filtersData.proveedor"
                :options="couriers"
                optionLabel="name"
                class="filter-container h-[42px]"
                placeholder="Proveedor"
                @change="$emit('getFilteredShipment')"
            >
                <template #value="slotProps">
                    {{ slotProps.value?.name || slotProps.placeholder }}
                </template>
            </Dropdown>
        </div>
        <div class="flex flex-col">
            <div class="my-1 text-gray-500">Fecha</div>
            <Calendar
                v-model="filtersData.fecha_rango"
                selectionMode="range"
                class="filter-container h-[42px]"
                :showIcon="true"
                :showButtonBar="true"
                placeholder="Rango de fecha"
                @hide="$emit('getFilteredShipment')"
            />
        </div>
        <Button
            label="Restablecer"
            class="p-button-text p-button-info h-[42px]"
            @click="$emit('clearFilters')"
        />
    </div>
</template>

<script>
export default {
    name: "CustomFilter",
    props: {
        filtersData: Object,
        proveedores: Object,
        clientes: Array,
        loading: Boolean,
    },
    data() {
        return {
            estados: [
                { value: "NO_RETIRADO", name: "Sin retirar" },
                { value: "RETIRADO", name: "Retirado" },
                { value: "ENTREGADO", name: "Entregado" },
            ],
        };
    },
    computed: {
        couriers() {
            return Object.keys(this.proveedores).map((id) => ({
                id: parseInt(id),
                name: this.proveedores[id],
            }));
        },
    },
};
</script>

<style>
div.p-accordion-header {
    display: none;
}

.p-accordion .p-accordion-content {
    border: none;
}

.search-bar .p-inputtext {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.search-bar .p-inputtext:enabled:focus {
    box-shadow: none;
}

.search-bar .p-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.custom-filter .p-dropdown .p-dropdown-label.p-placeholder {
    display: flex;
    align-items: center;
}

@media screen and (min-width: 600px) {
    .filter-container {
        max-width: 300px;
    }
}
</style>
